<template>
  <div class="sw-grid-flex sw-grid-flex--dir-column">
    <div class="sw-grid-flex sw-grid-flex--wrap sw-grid-flex--align-center">
      <div class="sw-grid-flex
                  sw-grid-flex--wrap
                  sw-grid-flex__cell-1-1
                  sw--padding-vert-2
                  sw-grid-flex--align-center
                  sw--padding-hor-2">
        <div class="sw-grid-flex__cell-1-3 sw-grid-flex--align-center sw-grid-flex">
          <h6>Resource Class</h6>
        </div>
        <div class="sw-grid-flex__cell-2-3 sw-grid-flex--align-center sw-grid-flex">
          <h6>Production Method</h6>
        </div>
      </div>
      <div v-if="showAddNewResourceClass" class="sw-grid-flex
                  sw-grid-flex--wrap
                  sw-grid-flex__cell-1-1
                  sw--padding-vert-2
                  sw-grid-flex--align-center
                  sw--padding-hor-2">
        <div class="sw-grid-flex__cell-1-3 sw-grid-flex--align-center sw-grid-flex">
            <div  class="sw-grid-flex__cell-1-2">
              <label>Resource name</label>
              <input
                type="text"
                class="sw--input-height__medium sw--font-size-14 sw--width-full"
                placeholder="Your new Resource name..."
                v-model="newResourceClass.name"
              />
            </div>

            <div class="sw-grid-flex__cell-1-2 sw--padding-left-2">
              <label class="sw--display-block">{{newResourceClass.newProductionFile.name}}</label>
              <select class="sw-select--not-round sw--width-half" v-model="newResourceClass.fileType">
                <option v-for="field in newResourceClass.newProductionFile.fields" :value="field.value">{{ field.name }}</option>
              </select>
            </div>
        </div>
        <div class="sw-grid-flex__cell-1-3 sw-grid-flex--align-center sw-grid-flex sw-grid-flex--wrap">

            <div class="sw-grid-flex__cell-1-3"
                 v-for="field in newResourceClass.newProductionMethod.fields"
                 :key="field.name">
              <label>{{field.text}}</label>
              <input v-model.number="field.value" class="sw--width-full">
            </div>
        </div>
        <div class="sw-grid-flex__cell-1-3 sw-grid-flex--align-center sw-grid-flex sw-grid-flex--wrap sw-grid-flex--justify-center">
          <button @click="showAddNewResourceClass = false" class="sw-dms-button sw--margin-right-3">Cancel</button>
        </div>
      </div>
      <div v-for="(resource, index) in resourceClasses"
           :key="'resource-' + resource.id"
           :class="index % 2 ? '': 'sw-dms--bg-grey-96'"
           class="sw-grid-flex
                  sw-grid-flex--wrap
                  sw-grid-flex__cell-1-1
                  sw--padding-vert-2
                  sw-grid-flex--align-center
                  sw--padding-hor-2">
        <div class="sw-grid-flex__cell-1-3 sw-grid-flex--align-center sw-grid-flex">
          <input
            type="checkbox"
            v-model="resourceClassesSelected"
            :value="resource.id"
            :disabled="!materialId">
          <h6
            class="sw--padding-left-2 sw--margin-0"
            :class="!materialId ? 'sw-dms--color-grey-46' : ''">
            {{resource.modelNumber}}
          </h6>
        </div>
        <div class="sw-grid-flex__cell-1-3">
          <select class="sw-select--not-round sw--width-full"
                  :disabled="!resourceClassesSelected.includes(resource.id)"
                  v-model="resourcePrinterMap[resource.id]">
            <option v-for="printer in printers"
                    :key="'printer-' + printer.id"
                    :value="printer.id">{{printer.title}}
            </option>
          </select>
        </div>
        <div class="sw-grid-flex__cell-1-3">
          <p v-if="resourcePrinterMap[resource.id]"
             class="sw--margin-0 sw--padding-left-3">
            <span class="sw--font-weight-bold">Min:</span>
            {{getPrinterById(resourcePrinterMap[resource.id]).xBoundMin}}x
            {{getPrinterById(resourcePrinterMap[resource.id]).yBoundMin}}x
            {{getPrinterById(resourcePrinterMap[resource.id]).zBoundMin}}
          </p>
          <p v-if="resourcePrinterMap[resource.id]"
             class="sw--margin-0 sw--padding-left-3">
            <span class="sw--font-weight-bold">Max:</span>
            {{getPrinterById(resourcePrinterMap[resource.id]).xBoundMax}}x
            {{getPrinterById(resourcePrinterMap[resource.id]).yBoundMax}}x
            {{getPrinterById(resourcePrinterMap[resource.id]).zBoundMax}}
          </p>
        </div>
      </div>
    </div>
    <bottom-banner
      :missing-info="!materialId ? ['Basic Information'] : []"
      v-on:saved="saveResourcePrinter"
      v-on:add-new="showAddNew"
      :show-saved-message="showSavedMessage"
      :show-add-new-btn="!showAddNewResourceClass"/>
  </div>

</template>

<script>

    import VueJQueryMixin from 'js/lib/vue/mixins/vue-jquery-mixin';
    import VueSwMixin from 'js/lib/vue/mixins/vue-sw-mixin';
    import BottomBanner from "rrViewComponents/Inshape/Admin/Materials/AddMaterial/BottomBannerComponent/bottom-banner";
    import _ from 'underscore';

    export default {
        name: "material-printer",
        components: {BottomBanner},
        mixins: [VueSwMixin, VueJQueryMixin],
        props: {
            materialId: {
                type: Number,
                required: false
            },
            printers: {
                type: Array,
                required: true
            },
            resourceClasses: {
                type: Array,
                required: true
            },
            currentMaterial: {
                type: Object,
                default: () => ({})
            }
        },
        created() {
            if (this.currentMaterial && !_.isEmpty(this.currentMaterial)) {
                let printerTechnologyIds = [];
                this.currentMaterial.printerTechnologies.forEach(item => {
                    this.resourcePrinterMap[item.resource_class_id] = item.production_method_id
                    this.resourceClassesSelected.push(item.resource_class_id);
                    printerTechnologyIds.push(item.printer_technology_material_id);
                });
            }
        },
        data: () => ({
            resourceClassesSelected: [],
            resourcePrinterMap: {},
            newResourceClass: {
                name: '',
                fileType:'',
                newProductionFile:{
                   name: 'File Type',
                   fields:[
                       {
                           name: 'STL',
                           value: 'stl'
                       },
                       {
                           name: 'WRL',
                           value: 'wrl'
                       }
                   ]
                },
                newProductionMethod: {
                    fields: [
                        {
                            name: 'xBoundMin',
                            text: 'X Min (cm)',
                            value: 0
                        },
                        {
                            name: 'yBoundMin',
                            text: 'Y Min (cm)',
                            value: 0
                        },
                        {
                            name: 'zBoundMin',
                            text: 'Z Min (cm)',
                            value: 0
                        },
                        {
                            name: 'xBoundMax',
                            text: 'X Max (cm)',
                            value: 0
                        },
                        {
                            name: 'yBoundMax',
                            text: 'Y Max (cm)',
                            value: 0
                        },
                        {
                            name: 'zBoundMax',
                            text: 'Z Max (cm)',
                            value: 0
                        }
                    ]
                }
            },
            showAddNewResourceClass: false,
            showSavedMessage: false,
        }),
        watch: {
            resourceClassesSelected(newVal, oldVal) {
                //if we uncheck a resource class
                if (newVal.length < oldVal.length) {
                    let differences = oldVal.filter(x => !newVal.includes(x));
                    //we need to also remove that key from the printer map
                    let temp_map = this.resourcePrinterMap;
                    differences.forEach(id => {
                        if (temp_map.hasOwnProperty(id)) {
                            delete temp_map[id];
                        }
                    })
                    this.resourcePrinterMap = temp_map;
                }
            }
        },
        methods: {
            showAddNew() {
                window.scrollTo(0, 0);
                this.showAddNewResourceClass = true;
            },
            getPrinterById(id) {
                return this.printers.find(printer => {
                    return printer.id === id;
                })
            },
            mapNewProductionMethodToObj() {
              let result = {};
                this.newResourceClass.newProductionMethod.fields.forEach(field => {
                    result[field.name] = field.value
                });
                result['minSumBbBox'] = result['xBoundMin'] + result['yBoundMin'] + result['zBoundMin'];
                return result;
            },
            saveResourcePrinter() {
                let _this = this;
                let _data = {resourcePrinterMap: _this.resourcePrinterMap};
                if (this.showAddNewResourceClass) {
                    _data['newPrinter'] = {
                        name: this.newResourceClass.name,
                        newProductionFileType: this.newResourceClass.fileType
                    };
                    _data['newPrinter']['newProductionMethod'] = this.mapNewProductionMethodToObj()
                }
                this.$jQuery.ajax({
                    type: 'POST',
                    url: '/admin/material/' + _this.materialId + '/printers',
                    dataType: 'json',
                    data: _data,
                    success: (data) => {
                        _this.$emit('success', data);
                        _this.showSavedMessage = true;
                        this.$sw.notifications.success('Saved!')
                    },
                    error: (jqXHR) => {
                        const response = JSON.parse(jqXHR.responseText);
                        _this.errorMessage = response.message;
                        _this.$emit('error', jqXHR);
                    }
                });
            }
        }
    }
</script>
